import FormattedMessage from 'I18n/components/FormattedMessage';
import { AIBadge } from 'ai-components-ui-library/components/informative/AIBadge';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Button } from 'foundations-components/transitional/components/Button';
import { ColumnSpreads } from 'foundations-components/transitional/components/ColumnSpreads';
import { ColumnWrapper } from 'foundations-components/transitional/components/ColumnWrapper';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { Section } from 'foundations-components/transitional/components/Section';
import { useState } from 'react';
import { useAIInsightsTracker } from '../useAIInsightsTracker';
import { AISettingsInstructions } from './AISettingsInstructions';
import { AISettingsPreview } from './AISettingsPreview';
import { AISettingsPreviewButton } from './AISettingsPreviewButton';
import { AISettingsSummaryStyle } from './AISettingsSummaryStyle';
import { AISettingsSummaryTone } from './AISettingsSummaryTone';
import { AsyncStatus } from 'reporting-data/asyncData/AsyncStatus';
import { getAIInsightsSummaryStyle } from 'reporting-data/report/reportGetters';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AISettings({
  report,
  reportResolve,
  onClose
}) {
  const [previewReport, setPreviewReport] = useState(report);
  const {
    trackAIInsightsEvent
  } = useAIInsightsTracker(previewReport);
  const [insight, setInsight] = useState('');
  const [insightStatus, setInsightStatus] = useState(AsyncStatus.UNINITIALIZED);
  function onApply() {
    trackAIInsightsEvent({
      action: 'applySettingsChanges'
    });
    onClose(previewReport);
  }
  function onCancel() {
    trackAIInsightsEvent({
      action: 'cancelSettingsChanges'
    });
    onClose();
  }
  return /*#__PURE__*/_jsxs(Modal, {
    width: "850px",
    children: [/*#__PURE__*/_jsxs(DialogHeader, {
      children: [/*#__PURE__*/_jsxs(Flex, {
        gap: "200",
        alignItems: "center",
        children: [/*#__PURE__*/_jsx(Text, {
          as: "h2",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-enablement.aiInsightsSettings.title"
          })
        }), /*#__PURE__*/_jsx(AIBadge, {})]
      }), /*#__PURE__*/_jsx(DialogCloseButton, {
        onClick: onCancel
      })]
    }), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Section, {
        children: /*#__PURE__*/_jsx(Text, {
          as: "p",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reporting-enablement.aiInsightsSettings.subtitle"
          })
        })
      }), /*#__PURE__*/_jsxs(ColumnWrapper, {
        alignItems: "stretch",
        children: [/*#__PURE__*/_jsxs(ColumnSpreads, {
          marginInlineEnd: "900",
          children: [/*#__PURE__*/_jsx(Section, {
            children: /*#__PURE__*/_jsx(AISettingsSummaryStyle, {
              previewReport: previewReport,
              onPreviewReportChange: setPreviewReport
            })
          }), /*#__PURE__*/_jsx(Section, {
            children: /*#__PURE__*/_jsx(AISettingsSummaryTone, {
              previewReport: previewReport,
              onPreviewReportChange: setPreviewReport
            })
          }), /*#__PURE__*/_jsx(AISettingsInstructions, {
            report: previewReport,
            onPreviewReportChange: setPreviewReport
          })]
        }), /*#__PURE__*/_jsx(ColumnSpreads, {
          children: /*#__PURE__*/_jsx(AISettingsPreview, {
            summaryStyle: getAIInsightsSummaryStyle(previewReport),
            insight: insight,
            insightStatus: insightStatus,
            resetInsightStatus: () => setInsightStatus(AsyncStatus.UNINITIALIZED)
          })
        })]
      }), /*#__PURE__*/_jsx(AISettingsPreviewButton, {
        previewReport: previewReport,
        reportResolve: reportResolve,
        setInsight: setInsight,
        setInsightStatus: setInsightStatus
      })]
    }), /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(Button, {
        use: "primary",
        onClick: onApply,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-enablement.aiInsightsSettings.button.apply"
        })
      }), /*#__PURE__*/_jsx(Button, {
        use: "tertiary",
        onClick: onCancel,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "reporting-enablement.aiInsightsSettings.button.cancel"
        })
      })]
    })]
  });
}